export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      {/* Footer content removed */}
    </footer>
  );
}
